import React from 'react';
import PropTypes from 'prop-types';

const SuggestedItemSeparator = ({ className, children }) => (
  <div className={className}>{children}</div>
);

SuggestedItemSeparator.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

SuggestedItemSeparator.defaultProps = {
  className: '',
  children: null,
};

export default SuggestedItemSeparator;
